"use client";
import { motion } from "framer-motion";

const Strip = ({ slim }: { slim: boolean }) => (
  <div className="flex flex-col gap-1 p-1.5">
    <span className="h-1.5 w-3/4 rounded-sm bg-card-foreground/70" />
    <span className="h-1 w-1/2 rounded-sm bg-card-foreground/25" />
    <div className="h-4 w-full rounded bg-neutral-200" />
    <div className={`grid gap-1 ${slim ? "grid-cols-1" : "grid-cols-3"}`}>
      <span className="h-2 rounded-sm bg-neutral-200" />
      {!slim && <span className="h-2 rounded-sm bg-neutral-200" />}
      {!slim && <span className="h-2 rounded-sm bg-neutral-200" />}
    </div>
    <span className="h-1 w-full rounded-sm bg-neutral-200" />
    <span className="h-1 w-4/5 rounded-sm bg-neutral-200" />
    <div className="h-3 w-full rounded border border-neutral-200 bg-neutral-100" />
  </div>
);

interface CapabilityMiniSiteProps {
  slim?: boolean;
  duration?: number;
}

const CapabilityMiniSite = ({
  slim = false,
  duration = 6,
}: CapabilityMiniSiteProps) => (
  <div className="flex h-full w-full flex-col overflow-hidden rounded-[3px] bg-white">
    <div className="flex shrink-0 items-center gap-1 bg-card-foreground px-1.5 py-1">
      <span className="size-1 rounded-full bg-white/70" />
      {!slim && <span className="ml-auto h-0.5 w-4 rounded bg-white/40" />}
    </div>
    <div className="relative flex-1 overflow-hidden">
      <motion.div
        className="absolute inset-x-0 top-0"
        animate={{ y: ["0%", "-50%"] }}
        transition={{ duration, repeat: Infinity, ease: "linear" }}
      >
        <Strip slim={slim} />
        <Strip slim={slim} />
      </motion.div>
    </div>
  </div>
);

export default CapabilityMiniSite;
